<!--<div class="example-header">
  <mat-form-field>
    <input matInput (keyup)="filter.next($event.target.value)" placeholder="Filter">
  </mat-form-field>
</div>-->


<div class="example-table-container">
  <div class="spinnerLoading"
       *ngIf="isLoadingResults">
    <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
  </div>
  <table mat-table [dataSource]="dataSource" class="example-table graphql-data-table"
         matSort matSortActive="created" matSortDisableClear matSortDirection="desc" multiTemplateDataRows>



    <!--<ng-container matColumnDef="{{select}}" *ngFor="let select of query.selects; let i = index">
      <th mat-header-cell *matHeaderCellDef>{{select}}</th>
      <td mat-cell *matCellDef="let row">{{row[select]}}</td>
    </ng-container>-->


    <ng-content></ng-content>


    <tr mat-header-row *matHeaderRowDef="_columns"></tr>
    <tr mat-row *matRowDef="let row; columns: _columns;"
        [class.expanded-row]="expandedRow === row"
        (click)="expandedRow = expandedRow === row ? null : row"
        [style.cursor]="expandedDetail != null ? 'pointer' : ''"
        ></tr>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="_columns.length">
        <div class="example-element-detail"
             [@detailExpand]="row == expandedRow ? 'expanded' : 'collapsed'">
          <ng-container *ngTemplateOutlet="expandedDetail;context:{row, expanded:row == expandedRow}"></ng-container>
        </div>
      </td>
    </ng-container>
    <ng-container *ngIf="expandedDetail != null">
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </ng-container>
  </table>
</div>


<mat-paginator [length]="resultsLength" [pageSize]="10" [pageSizeOptions]="[10,20,30]"></mat-paginator>
<button class="refresh-button" mat-button (click)="refreshSubject.next(null)"><mat-icon>refresh</mat-icon></button>
